/* eslint-disable import/no-cycle */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ActionIcon, Indicator, Tooltip } from '@mantine/core';
import { ShoppingCart, User } from 'tabler-icons-react';
import WsShareButtonsDisplay from '../../blocks/shareButtons/WsShareButtonsDisplay';

const WsHeaderUtilityButtons = ({
  config,
  themeConfig,
  ecomStoreTheme,
  menuColorScheme,
  headerColorScheme,
  productCount,
  baseStoreUrl,
  editModeEnabled,
  builderHasAuthenticated,
  onNavigate,
  authState
}) => {
  const showSocialSharing = config.showSocialSharing === 'true';
  const showTooltips = config.showTooltips === 'true';
  const shareImageUrl =
    themeConfig.socialShareImage ?? ecomStoreTheme.ecomStore.logoImageUrl;

  const isSignedOut =
    (editModeEnabled && !builderHasAuthenticated) || !authState.isAuthenticated;

  return (
    <>
      {/* <ActionIcon
            color="dark"
            component={Link}
            onClick={onNavigate}
            radius="lg"
            size="lg"
            to={`${baseStoreUrl}/search`}
            variant="subtle"
          >
            <Search color={headerColorScheme.textColor} />
          </ActionIcon> */}

      {showSocialSharing && (
        <WsShareButtonsDisplay
          baseStoreUrl={baseStoreUrl}
          buttonFlow={config.shareButtonFlow}
          colorScheme={headerColorScheme}
          isHeader
          menuColorScheme={menuColorScheme}
          shareImageUrl={shareImageUrl}
          showTooltips={showTooltips}
          themeConfig={themeConfig}
        />
      )}

      <Tooltip
        disabled={!showTooltips}
        label="Account"
        position="bottom"
        styles={{
          tooltip: {
            backgroundColor: menuColorScheme.backgroundColor,
            color: menuColorScheme.textColor
          }
        }}
        withArrow
      >
        <ActionIcon
          color="dark"
          component={Link}
          onClick={onNavigate}
          radius="lg"
          size="lg"
          to={
            isSignedOut
              ? `${baseStoreUrl}/account/login`
              : `${baseStoreUrl}/account/details`
          }
          variant="subtle"
        >
          <User color={headerColorScheme.textColor} />
        </ActionIcon>
      </Tooltip>
      <Tooltip
        disabled={!showTooltips}
        label="Cart"
        position="bottom"
        styles={{
          tooltip: {
            backgroundColor: menuColorScheme.backgroundColor,
            color: menuColorScheme.textColor
          }
        }}
        withArrow
      >
        <Indicator
          disabled={productCount === 0}
          inline
          label={productCount}
          size={16}
        >
          <ActionIcon
            color="dark"
            component={Link}
            onClick={onNavigate}
            radius="lg"
            size="lg"
            to={`${baseStoreUrl}/checkout/cart`}
            variant="subtle"
          >
            <ShoppingCart color={headerColorScheme.textColor} />
          </ActionIcon>
        </Indicator>
      </Tooltip>
    </>
  );
};

WsHeaderUtilityButtons.propTypes = {
  authState: PropTypes.object,
  baseStoreUrl: PropTypes.string,
  builderHasAuthenticated: PropTypes.bool,
  config: PropTypes.object,
  ecomStoreTheme: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  headerColorScheme: PropTypes.object,
  menuColorScheme: PropTypes.object,
  onNavigate: PropTypes.func,
  productCount: PropTypes.number,
  themeConfig: PropTypes.object
};

export default WsHeaderUtilityButtons;
